<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>标准库存</el-breadcrumb-item>
      <el-breadcrumb-item>{{
        this.$route.query.orderId == undefined ? "新增库存" : "新增库存"
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <dev>
      <el-form
        ref="form"
        :model="orderData.order"
        :rules="newOrderFormRules"
        label-width="80px"
        size="mini"
      >
        <el-row>
          <el-col :span="4"><p class="text_l">标准库存信息</p></el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item prop="orderNo" label="标准库存编号">
              <el-input
                v-model="orderData.order.orderNo"
                style="width: 90%"
                @blur="checkNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="orderData.order.orderDateTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                disabled
                style="width: 90%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="orderStatus" label="库存状态">
              <el-select
                v-model="orderData.order.orderStatus"
                placeholder="请选择"
                style="width: 90%"
                disabled
              >
                <el-option
                  label="标准库存订单"
                  value="标准库存订单"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="orderType" label="库存类型">
              <el-select
                v-model="orderData.order.orderType"
                placeholder="请选择"
                style="width: 90%"
                disabled
              >
                <el-option label="库存订单" value="库存订单"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="quantity" label="生产完成库存数量">
              <el-input
                v-model="orderData.order.quantity"
                disabled
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item prop="quantityProduction" label="标准模版数量">
              <el-input
                v-model="orderData.order.quantityProduction"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              prop="quantityProductionCompletionTime"
              label="库存完成时间"
            >
              <el-date-picker
                v-model="orderData.order.quantityProductionCompletionTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                style="width: 90%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4"><p class="text_l">产品信息</p></el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <el-form-item prop="productName" label="产品名称">
              <el-input
                v-model="orderData.order.productName"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="colour" label="颜色">
              <el-input
                v-model="orderData.order.colour"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="speModel" label="规格型号">
              <el-input
                v-model="orderData.order.speModel"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="sheetMaterial" label="板材材料">
              <el-select
                v-model="orderData.order.sheetMaterial"
                placeholder="请选择"
                style="width: 90%"
              >
                <el-option label="实木多层板" value="实木多层板"></el-option>
                <el-option label="实木颗粒板" value="实木颗粒板"></el-option>
                <el-option
                  label="实木颗粒板和多层板混合"
                  value="实木颗粒板和多层板混合"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="shop" label="店铺">
              <el-input
                v-model="orderData.order.shop"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item
              label="备注"
              width="200%"
              show-overflow-tooltip="false"
            >
              <el-input
                type="textarea"
                v-model="orderData.order.remarks"
                style="width: 95%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="margin-top: 1%">
          <el-col :span="4">
            <el-form-item size="large">
              <el-button type="primary" @click="onSubmit"
                >保存标准库存订单</el-button
              >
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item>
              <el-upload
                action="/api/file/upload"
                :on-success="uploadImageSuccess"
                :headers="myHeaders"
                :show-file-list="false"
                multiple
              >
                <el-button size="small" type="primary">点击上传图片</el-button>
                <div slot="tip" class="el-upload__tip">
                  只支持jpg/png文件，不超过500kb
                </div>
              </el-upload>
            </el-form-item>
          </el-col>

          <draggable
            v-model="orderData.fileInfoList"
            :move="onMove"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <transition-group type="transition">
              <dev
                style="margin-left: 1%"
                v-for="item in orderData.fileInfoList"
                :key="item"
                class="item"
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="item.fileUrl"
                  :preview-src-list="[item.fileUrl]"
                >
                </el-image>
                <el-button
                  @click="delImage(item.fileUrl)"
                  style="color: red"
                  size="mini"
                  >删除</el-button
                >
              </dev>
            </transition-group>
          </draggable>
        </el-row>
      </el-form>
    </dev>
  </div>
</template>

<script>
var token = window.localStorage.getItem("token");
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data() {
    var orderNoCheck = async (rule, value, cb) => {
      var regular = /^[0-9a-zA-Z-_\u4e00-\u9fa5]{1,}$/;
      if (!regular.test(value)) {
        return cb(new Error("只能由字母数字汉字-_组成!"));
      }

      const { data: res } = await this.$http.get(
        "/api/standard-inventory-order/order-no-check/" + value
      );
      if (res.code !== 1) {
        return cb(new Error("标准库存编号已存在，请更换标准库存编号！"));
      }
    };
    // 修改numberChcek规则,以便使生辰完成库存数量可以为0,甲方爸爸要求这里数量修改为0
    var numberCheck = async (rule, value, cb) => {
      var isNum = /^([0-9][\d]{0,4})?$/;
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !isNum.test(value)
      ) {
        return cb(new Error("请输入5位以内正整数！"));
      }
    };
    var numberCheck0 = async (rule, value, cb) => {
      var isNum = /^([1-9]\d*|[0]{1,1})$/;
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !isNum.test(value)
      ) {
        return cb(new Error("请输入大于等于0的数字！"));
      }

      if (value > 99999) {
        return cb(new Error("请输入5位以内的数字！"));
      }
    };
    var speModelCheck = async (rule, value, cb) => {
      var regular = /^[0-9*/]{1,}$/;
      if (!regular.test(value)) {
        return cb(new Error("只能包含数字*/"));
      }
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          //设置选择今天以及今天之后的日期
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      myHeaders: { Authorization: token },
      orderData: {
        order: {
          orderNo: "标准_",
          orderStatus: "标准库存订单",
          orderDateTime: "",
          orderType: "标准库存订单",
          productName: "",
          colour: "",
          speModel: "",
          quantity: 0,
          // 修改默认生产完成库存数量为0
          remarks: "",
          used: 0,
          quantityProduction: 0,
          quantityProductionUsed: 0,
          useComplete: 0,
          sheetMaterial: null,
        },
        fileInfoList: [],
      },
      newOrderFormRules: {
        orderNo: [
          { required: true, message: "请填写库存编号", trigger: "blur" },
          { validator: orderNoCheck, trigger: "blur" },
        ],
        productName: [{ required: true, message: "产品名称", trigger: "blur" }],
        colour: [{ required: true, message: "颜色", trigger: "blur" }],
        speModel: [
          { required: true, message: "规格型号", trigger: "blur" },
          { validator: speModelCheck, trigger: "blur" },
        ],
        quantity: [
          { required: true, message: "数量", trigger: "blur" },
          { validator: numberCheck, trigger: "blur" },
        ],
        sheetMaterial: [
          { required: true, message: "板材材料", trigger: "blur" },
        ],
        quantityProduction: [
          { required: true, message: "标准模版数量", trigger: "blur" },
          { validator: numberCheck0, trigger: "blur" },
        ],
      },
      orderImageSrcS: [],
      orderImageFileInfoList: [],
    };
  },
  methods: {
    onSubmit() {
      // console.log("@@@@");
      //后端将order改成了standardInventoryOrder
      //fileInfoList 改成了standardInventoryFileInfos
      //为了最大的减少代码的改动，这里手动将变量名做一个更改
      // let tmp = this.orderData;
      // let res1 = JSON.parse(
      //   JSON.stringify(tmp).replace(/order/, "standardInventoryOrder")
      // );
      // // console.log("res1", res1);
      // let res2 = JSON.parse(
      //   JSON.stringify(res1).replace(
      //     /fileInfoList/,
      //     "standardInventoryFileInfos"
      //   )
      // );
      // this.orderData = res2;
      // console.log("res2", res2);

      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(
            "/api/standard-inventory-order/create",
            this.orderData
          );
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        } else {
          this.$message({
            message: "有必填项未填写或不合法！",
            type: "error",
          });
          return false;
        }
      });
    },
    initParams() {
      //this.orderData.order.orderNo = "8"+new Date().getTime()
      this.orderData.order.orderDateTime = this.getNowFormatDateTime();
    },
    uploadImageSuccess(response) {
      if (response.code == 1) {
        this.orderData.fileInfoList.push(response.data);
      } else {
        this.$message({
          message: response.msg,
          type: "error",
        });
      }
    },
    delImage(fileUrl) {
      for (let i = 0; i < this.orderData.fileInfoList.length; i++) {
        if (this.orderData.fileInfoList[i].fileUrl == fileUrl) {
          this.orderData.fileInfoList.splice(i, 1);
          break;
        }
      }
    },
    // 图片移动
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.item;
      const draggedElement = draggedContext.item;
    },
    async getOrderInfo(orderId) {
      const { data } = await this.$http.get("/api/order/getById/" + orderId);
      if (data.code == 1) {
        this.orderData.fileInfoList = data.data.fileInfoList;
        this.orderData.order.productName = data.data.order.productName;
        this.orderData.order.colour = data.data.order.colour;
        this.orderData.order.speModel = data.data.order.speModel;
        this.orderData.order.sheetMaterial = data.data.order.sheetMaterial;
        this.orderData.order.remarks = data.data.order.remarks;
        this.orderData.order.shop = data.data.order.shop;
      }

      this.initParams();
    },
    //checkNo用于检查输入框中订单编号的合法性,保证用户每次在该页面输入的订单中都会以"标准_"字样开头
    checkNo() {
      // let tmp = this.orderData.order.orderNo.substring(0, 3);
      // 检查字符
      if (this.orderData.order.orderNo.substring(0, 3) == "标准_") {
        // console.log("合法订单号");
        // 订单号合法,不需要对订单编号做处理
      } else {
        this.orderData.order.orderNo = "标准_" + this.orderData.order.orderNo;
        // console.log(this.orderData.order.orderNo);
        this.$message.error("标准库存编号应该以“标准_”开头,以自动补全,请核查");
      }
    },
  },
  created() {
    //解除其他页面的按键监听
    document.onkeydown = null;

    if (this.$route.query.orderId != undefined) {
      //查询正单系统订单填充数据
      this.getOrderInfo(this.$route.query.orderId);
    } else {
      this.initParams();
    }
  },
};
</script>

<style>
.text_l {
  font-size: 15px;
  margin-top: 0px;
  margin-bottom: 7px;
  font-weight: bold;
}
.text {
  font-size: 13px;
}
.text_del_image {
  font-size: 10px;
}
</style>
